import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { OrderProto } from "@noom/noom-contracts/noom_contracts/billing/bms/orders/orders_service";
import { useSelector } from "react-redux";
import { CoreReduxState } from "../store";
import { BillingIntervalProto } from "@noom/noom-contracts/noom_contracts/billing/billing_interval";
import { MED_SKU } from "src/utils/medEligibility";
import { TaxEntryProto } from "@noom/noom-contracts/noom_contracts/billing/revrec/model/revrec_entry";
import { PaymentScheduleProto_LineItemProto } from "@noom/noom-contracts/noom_contracts/billing/bms/common/payment_schedule";
import { BillingUserProto } from "@noom/noom-contracts/noom_contracts/billing/user/billing_user";

export type SaleItemInfo = {
  medSku?: MED_SKU;
  saleItemId?: string;
  trialSaleItemId?: string;
  planName?: string;
};

export type CheckoutPlan = {
  currency: string;
  billingInterval: BillingIntervalProto;
  recurringLineItem: PaymentScheduleProto_LineItemProto;
  recurringTaxEntry?: TaxEntryProto;
  recurringLineItemPeriodStartTime?: string;
  trialBillingInterval: BillingIntervalProto;
  trialLineItem: PaymentScheduleProto_LineItemProto;
  trialTaxEntry?: TaxEntryProto;
};

export type CheckoutOrdersState = {
  saleItem?: SaleItemInfo;
  billingUser?: BillingUserProto;
  order?: OrderProto;
  plan?: CheckoutPlan;
};

const checkoutOrdersStateSlice = createSlice({
  name: "checkoutOrdersState",
  initialState: {} as CheckoutOrdersState,
  reducers: {
    setCheckoutOrders: (state, action: PayloadAction<CheckoutOrdersState>) => {
      return {
        ...state,
        ...action.payload,
      };
    },
    setCheckoutSaleItem: (state, action: PayloadAction<SaleItemInfo>) => {
      return {
        saleItem: action.payload,
        billingAddress: undefined,
        order: undefined,
        plan: undefined,
      };
    },
    setBillingUser: (state, action: PayloadAction<BillingUserProto>) => {
      return {
        ...state,
        billingUser: action.payload,
      };
    },
  },
});

export const { setCheckoutOrders, setCheckoutSaleItem, setBillingUser } =
  checkoutOrdersStateSlice.actions;
export default checkoutOrdersStateSlice;

export function useCheckoutOrders() {
  return useSelector((state: CoreReduxState) => state.checkoutOrders);
}
